import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import type { RouterContext } from "@/router/context";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Outlet />
    </div>
  );
}

function NotFound() {
  return (
    <main className="mx-auto flex min-h-[60vh] max-w-5xl flex-col items-center justify-center gap-2 px-6 text-center">
      <h1 className="font-display text-3xl font-bold tracking-tight">
        Pagina niet gevonden
      </h1>
      <p className="text-muted-foreground">
        De pagina die je zoekt bestaat niet.
      </p>
    </main>
  );
}
